import React, { ReactElement, useState, useEffect } from 'react'
import { orderBy } from 'lodash'
import { Cards } from '../../styled-components'

/* import { deleteTraining } from '../../../../api/training' */
import { Training, TrainingGroup } from '../../../../types/training'
/* import { Alert } from '../../../../constants/sweet-alert' */
import TrainingAddEdit from '../add-edit-training'
import Card from '../../card'
import AdminTemplate from '../../../base-template'
import { deleteTraining } from '../../../../api/training'
import { Alert } from '../../../../constants/sweet-alert'
import DeleteModal from '../../../delete-modal'

interface TrainingCardsProps {
  trainingsGroup: TrainingGroup
  adminTemplate: boolean
}

const TrainingCards = ({
  trainingsGroup,
  adminTemplate,
}: TrainingCardsProps): ReactElement => {
  const { trainings, name: type, title } = trainingsGroup
  const [editTraining, setEditTraining] = useState<Training | undefined>(
    undefined
  )
  const [loadingDelete, setLoadingDelete] = useState<boolean>(false)
  const [deletedTraining, setDeletedTraining] = useState<Training>()

  const [addTraining, setAddTraining] = useState<
    Omit<Training, 'categories'> | undefined
  >(undefined)
  const [allTrainings, setAllTrainings] = useState<Training[]>([])
  useEffect(() => {
    setAllTrainings(trainings)
  }, [trainings])

  const removeTraining = () => {
    setLoadingDelete(true)
    deleteTraining(deletedTraining?.id).then((result) => {
      if (result === 200) {
        const findTrainingIndex = trainings?.findIndex(
          (el) => el.id === deletedTraining?.id
        )
        const oldTrainings = trainings
        oldTrainings?.splice(findTrainingIndex as number, 1)
        setAllTrainings(oldTrainings)
        setDeletedTraining(undefined)
        Alert.fire({
          icon: 'success',
          title: `Deleted`,
        })
      } else {
        Alert.fire({
          icon: 'error',
          title: `Error`,
        })
      }
      setLoadingDelete(false)
    })
  }

  return (
    <>
      {deletedTraining ? (
        <DeleteModal
          onCancel={() => setDeletedTraining(undefined)}
          title={deletedTraining.title}
          onDelete={() => removeTraining()}
          loadingDelete={loadingDelete}
        />
      ) : null}
      <AdminTemplate
        onAddClick={() =>
          setAddTraining({
            id: '',
            title: '',
            code: '',
            isWhat: type,
            description: '',
            isVisible: false,
          })
        }
        adminTemplate={adminTemplate}
        navigation={[
          {
            title,
            link: `/trainings?type=${type}`,
          },
        ]}
      >
        {addTraining ? (
          <TrainingAddEdit
            trainingGroupId={trainingsGroup.id}
            onClose={() => setAddTraining(undefined)}
            training={addTraining}
          />
        ) : editTraining ? (
          <TrainingAddEdit
            trainingGroupId={trainingsGroup.id}
            onClose={() => setEditTraining(undefined)}
            training={editTraining}
          />
        ) : (
          <>
            <Cards>
              {orderBy(allTrainings, ['placement']).map((training) => (
                <Card
                  key={training.id}
                  element={training}
                  onClickEdit={(t) => setEditTraining(t as unknown as Training)}
                  onDeleteClick={(t) =>
                    setDeletedTraining(t as unknown as Training)
                  }
                  link={`/trainings?type=${type}&training_id=${training.id}`}
                />
              ))}
            </Cards>
          </>
        )}
      </AdminTemplate>
    </>
  )
}

export default TrainingCards
